import type { ControlInspector } from "./types"

export const checkbox: ControlInspector<"checkbox"> = {
  // Nothing of its own: the label beside the box is the field's name.
  Inspector: () => null,
}
